import { render, staticRenderFns } from "./zCentralizedToolbar.vue?vue&type=template&id=564e38bd&scoped=true&"
import script from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"
export * from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e38bd",
  null
  
)

export default component.exports